import { FeatureToggles } from 'interfaces/FeatureToggle.interface';
import { createContext, FunctionComponent } from 'preact';
import { useContext } from 'preact/hooks';

type FeatureConfigContextValue = {
  featureToggles: FeatureToggles;
};

const FeatureConfigContext = createContext<FeatureConfigContextValue>(null);

interface IFeatureConfigContext {
  contextValue: FeatureConfigContextValue;
  children: React.ReactNode;
}

const FeatureConfigProvider: FunctionComponent<IFeatureConfigContext> = ({
  contextValue,
  children,
}) => {
  return (
    <FeatureConfigContext.Provider value={contextValue}>
      {children}
    </FeatureConfigContext.Provider>
  );
};

const useFeatureToggleContext = (): FeatureToggles => {
  const ctx = useContext(FeatureConfigContext);
  return ctx?.featureToggles;
};

export { FeatureConfigProvider, useFeatureToggleContext };
